export default "__VITE_ASSET__Ddv3xbUM__"